<template>
  <div>
    <!-- Cotizador de Alfombras -->
    <section-header
      header=""
      sub-header="Haga una cotización en tiempo real"
      text=""
    />
    <v-card class="mx-auto" max-width="580" hover>
      <v-card-title>Cotizador Citrus Clean</v-card-title>
         <v-card-text>Tipo de servicio</v-card-text>
             <v-container fluid>
               <v-radio-group v-model="cotizador" :mandatory="false" v-if="cotizador == 0" >
                 <v-radio label="Alfombra" value="1"></v-radio>
                 <v-radio label="Sala" value="2"></v-radio>
                 <v-radio label="Tapete" value="3"></v-radio>
                 <v-radio label="Auto" value="4"></v-radio>
                 <v-radio label="Colchones" value="5"></v-radio>
                 <v-radio label="Sillas" value="6"></v-radio>
               </v-radio-group>
               <!-- Cotizador de Alfombras -->
              <v-text-field
                v-if="cotizador == 1"
                v-model.number="model"
                :label="label"
                single-line
                solo
                color="#5AB55E"
                class="black--text"
                />
               <div class="mt-12 text-center" v-if="cotizador == 1" >
                 <p class="black--text">
                  Costo aproximado: $ {{ model*25 }}
                  </p>
              </div>
               <v-btn
                 center
                 v-if="cotizador == 1"
                 color="green"
                 depressed
                 tile
                 dark
                 :href="linkcreator(' limpieza de alfombra ', ` Metros cuadrados: ${model} Precio: ${model*25}  `)"
                 target="_blank"
               >
                Precio/contratar!
               </v-btn>
                <!-- Cotizador de Alfombras -->
                <!-- Cotizador de Salas -->
    <v-text-field
     v-if="cotizador == 2"
      v-model.number="model2"
      :label="label2"
      single-line
      solo
      color="#5AB55E"
      class="black--text"
    />
    <div class="mt-12 text-center"  v-if="cotizador == 2">
      <p class="black--text">
        Costo aproximado: $ {{ model2*125 }}
      </p>
    <v-btn
      color="green"
       v-if="cotizador == 2"
      depressed
      tile
      dark
      :href="linkcreator(' limpieza de salas ', ` ${model2} salas con costo total de $ ${model2*125} pesos por el servicio`)"
      target="_blank"
    >
     Precio/contratar!
    </v-btn>
    </div>
                <!-- Cotizador de Salas -->
                <!-- Cotizador de Tapetes -->
     <v-text-field
      v-model.number="model3"
       v-if="cotizador == 3"
      :label="label3"
      single-line
      solo
      color="#5AB55E"
      class="black--text"
    />
    <div class="mt-12 text-center"  v-if="cotizador == 3">
      <p class="black--text">
        Costo aproximado: $ {{ model3*130 }}
      </p>
    <v-btn
     v-if="cotizador == 3"
      color="green"
      depressed
      tile
      dark
      :href="linkcreator(' limpieza de tapetes ', ` ${model3} tapetes con costo total de $ ${model3*130} pesos por el servicio`)"
      target="_blank"
    >
     Precio/contratar!
    </v-btn>
    </div>   
                <!-- Cotizador de Tapetes -->
                <!-- Cotizador de Autos -->
    <p  v-if="cotizador == 4" class ="black--text"> $ {{ radios || 'null' }}</p>
    <v-radio-group v-model="radios" :mandatory="false" v-if="cotizador == 4">
      <v-radio label="Auto chico" value="800"></v-radio>
      <v-radio label="Camioneta" value="1000"></v-radio>
    </v-radio-group>
    <v-btn
    v-if="cotizador == 4"
      color="green"
      depressed
      tile
      dark
      :href="linkcreator(' limpieza de auto ', `con precio $ ${radios} `)"
      target="_blank"
    >
     Precio/contratar!
    </v-btn>
                <!-- Cotizador de Autos -->
                <!-- Cotizador de Colchones -->
    <p  v-if="cotizador == 5" class ="black--text"> $ {{ radios || 'null' }}</p>
    <v-radio-group v-model="radios" :mandatory="false" v-if="cotizador == 5">
      <v-radio label="King Size" value="450"></v-radio>
      <v-radio label="Queen Size" value="420"></v-radio>
      <v-radio label="Matrimonial" value="380"></v-radio>
      <v-radio label="Individual" value="320"></v-radio>
    </v-radio-group>
    <v-btn
    v-if="cotizador == 5"
      color="green"
      depressed
      tile
      dark
      :href="linkcreator(' limpieza de colchones ', ` colchon de precio $ ${radios} `)"
      target="_blank"
    >
     Precio/contratar!
    </v-btn>
                <!-- Cotizador de Colchones -->
                <!-- Cotizador de Sillas -->
    <p class ="black--text" v-if="cotizador == 6"> $ {{ radios2 || 'null' }}</p>
    <v-radio-group v-model="radios2" :mandatory="false" v-if="cotizador == 6">
      <v-radio label="Un solo asiento" value="30"></v-radio>
      <v-radio label="Forro completo" value="50"></v-radio>
    </v-radio-group>
    <v-btn
    v-if="cotizador == 6"
      color="green"
      depressed
      tile
      dark
      :href="linkcreator(' limpieza de asientos ', ` asientos de precio $ ${radios2} `)" 
      target="_blank"
    >
     Precio/contratar!
    </v-btn>
    <br>          
    <br>
    <v-card-actions>             
    <v-btn
                 @click="resetButton"
                 color="black"
                 depressed
                 tile
                 dark
                 small
                 right
                 rounded
               >
                Menu principal
               </v-btn>
     </v-card-actions>
    </v-container>         
    </v-card>
  </div>
</template>

<script>
  export default {
    data: () => ({
      opcion: true,
      number: '',
      cotizador: 0,
      radios: '0',
      radios2: '0',
      model: '',
      label: 'Ingrese los metros cuadrados de su alfombra',
      model2: '',
      label2: 'Ingrese el número de asientos de su sala',
      model3: '',
      label3: 'Ingrese los metros cuadrados de su tapete',
    }),
    computed: {

    },
    methods:{
      linkcreator(servicio, numero){
        var link = "https://api.whatsapp.com/send?phone=522214191449&text=%C2%A1Hola! quiero un servicio de" + servicio + 
        "con las siguientes características:" + numero;
        return link
      },
      resetButton(){
        this.cotizador = 0;
      }
    }

  }
</script>

<style scoped>

</style>
